var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"350px"},attrs:{"id":"myMap"}},[_c('l-map',{attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_vm._v(" "),_c('l-geojson',{attrs:{"geojson":_vm.geojson,"options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }